"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classnames = _interopRequireDefault(require("classnames"));

var _LazyImage = _interopRequireDefault(require("@insided/shared/uikit/LazyImage"));

var _trackingLink = _interopRequireDefault(require("@insided/deprecated-preact-components/link/tracking-link"));

var _Metadata = _interopRequireDefault(require("@insided/deprecated-preact-components/widget-category-and-topic-stream/Metadata"));

var _ChevronRight = _interopRequireDefault(require("@insided/shared/icons/ChevronRight"));

var _ChevronUp = _interopRequireDefault(require("@insided/shared/icons/ChevronUp"));

var ContentCategory = function ContentCategory(_ref) {
  var category = _ref.category,
      key = _ref.key,
      displayUnreadPostCount = _ref.displayUnreadPostCount,
      attachmentCdn = _ref.attachmentCdn,
      unreadTopicsAndRepliesCount = _ref.unreadTopicsAndRepliesCount,
      setCategories = _ref.setCategories;
  return (0, _preact.h)("div", {
    className: "table__row qa-table-row".concat(displayUnreadPostCount ? ' js-unread-row' : '', " forum-default qa-forum--default "),
    key: key,
    "data-value": category.id
  }, (0, _preact.h)("div", {
    className: (0, _classnames.default)('table__cell', 'grid--7', 'cell--S--first')
  }, (0, _preact.h)("div", {
    className: "user flag"
  }, (0, _preact.h)("div", {
    className: "flag__image"
  }, (0, _preact.h)("div", {
    className: "forum-image"
  }, category.thumbnailImage && (0, _preact.h)(_LazyImage.default, {
    type: "img",
    src: (0, _absoluteUrlRuntime.resolveUrl)("".concat(attachmentCdn).concat(category.thumbnailImage)),
    title: category.title,
    alt: category.title,
    displayOriginalImage: true
  }))), (0, _preact.h)("div", {
    className: "user_data flag__body"
  }, (0, _preact.h)("div", {
    className: "category-title"
  }, (0, _preact.h)("h3", null, (0, _preact.h)(_trackingLink.default, {
    tag: "a",
    href: (0, _absoluteUrlRuntime.resolveUrl)(category.url),
    className: (0, _classnames.default)('link--quiet', 'link--topic', 'link--subforum', 'qa-forum-overview-subforum'),
    track: {
      type: 'Category Clicked',
      category_title: category.title,
      category_url: category.url,
      click_source: 'Homepage',
      category_type: 'category'
    },
    gaEvents: {
      eventCategory: 'Homepage',
      eventAction: 'Category clicked',
      eventLabel: {
        Title: category.title,
        Link: category.url,
        Type: 'community'
      }
    }
  }, category.title)), category.isContainer && (0, _preact.h)("span", {
    tabIndex: 0,
    role: "button",
    title: "forum expand",
    className: (0, _classnames.default)('table__collapse', 'collapse-trigger', 'js-collapse-trigger'),
    onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", setCategories(category.id));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })),
    onKeyUp: /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(e) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", e.code === 'Enter' ? setCategories(category.id) : null);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }()
  }, category.isContainer ? (0, _preact.h)(_ChevronRight.default, {
    width: 24,
    height: 24,
    fill: "currentColor"
  }) : (0, _preact.h)(_ChevronUp.default, {
    width: 24,
    height: 24,
    fill: "currentColor"
  }))), (0, _preact.h)(_Metadata.default, {
    category: category,
    unreadTopicsAndRepliesCount: unreadTopicsAndRepliesCount
  })))));
};

var _default = ContentCategory;
exports.default = _default;